
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ErrorHandler } from 'utilities/error';
import { DataHandler } from 'utilities/data';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { OperatorType } from 'app/models/operatortype';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  withCredentials: true
};

@Injectable()
export class OperatorTypeService {
    private apiPath = 'api/EDWOperatorTypes';
    private requestUrl = environment.serviceUrl + this.apiPath;

    constructor(private http: HttpClient) { }

    /**
     * Gets all Operator Types
     * @author Nash Lindley
     */
    getOperatorTypes(): Observable<any> {
        return this.http.get<OperatorType[]>(this.requestUrl, httpOptions).pipe(
            catchError(new ErrorHandler().handleError));
    }

}
